// src/services/salesService.js
//
// Wraps /api/sales/* backend calls for Leads and Meetings.
import { api } from './api';

export const salesService = {
  // Leads
  getLeads: (status, platform) => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (platform) params.append('platform', platform);
    const qs = params.toString();
    return api.get('/api/sales/leads' + (qs ? '?' + qs : ''));
  },

  getLead: (id) =>
    api.get('/api/sales/leads/' + id),

  createLead: (data) =>
    api.post('/api/sales/leads', data),

  updateLead: (id, data) =>
    api.put('/api/sales/leads/' + id, data),

  deleteLead: (id) =>
    api.delete('/api/sales/leads/' + id),

  // Feature: Lead attribution - list active Sales Reps for the dropdown
  getSalesReps: () =>
    api.get('/api/sales/reps'),

  // Meetings
  logMeeting: (data) =>
    api.post('/api/sales/meetings', data),

  getLeadMeetings: (leadId) =>
    api.get('/api/sales/meetings/lead/' + leadId),

  getAllMeetings: (requiresCeo) => {
    const qs = requiresCeo !== undefined ? '?requires_ceo=' + requiresCeo : '';
    return api.get('/api/sales/meetings' + qs);
  }
};